/** @jsx h */
import { h } from 'preact'

import t from '../../utils/translate'

/**
 * A Component that renders a list of static Proof Points. These are not meant to be interactive.
 * The two Proof Points are Vegan and Partly Recyclable Packaging and they're
 * both styled as 'verified', with an extra Theme Tag on top of them.
 * At time of writing, this component is only used in the About modal.
 */
const StaticCapsuleList = () =>
  <ul class='CapsuleList' aria-hidden='true'>
    <li class='CapsuleList-item'>
      <div class='CapsuleList-item--button'>
        <div class='Capsule'>
          <div class='Capsule-icon Capsule-icon--claim'>
            <svg
              xmlns='http://www.w3.org/2000/svg' width='44' height='44' viewBox='0 0 44 44' fill='none'
              class='Capsule-iconInner' preserveAspectRatio='xMaxYMax meet'
            >
              <path
                fill-rule='evenodd' clip-rule='evenodd'
                d='M12.6612 20.3575L11.6445 19.6981C11.7024 19.6946 11.7343 19.6906 11.765 19.6906H16.0173C16.0791 19.6816 16.1388 19.7168 16.1609 19.7751C16.7526 21.0102 17.3458 22.2453 17.9406 23.4804C17.9527 23.5053 17.962 23.5319 17.9829 23.5834L16.935 22.9037C16.9106 22.9402 16.8904 22.9692 16.8713 22.9993C16.1352 24.1332 15.4 25.2674 14.6655 26.4017C14.4698 26.7045 14.2753 27.0085 14.0923 27.3188C14.0184 27.454 13.9564 27.5954 13.9071 27.7414C13.8706 27.8399 13.8439 27.9417 13.8272 28.0454C13.8149 28.1494 13.808 28.2539 13.8063 28.3586C13.7919 28.3383 13.7768 28.3215 13.7658 28.3007C12.8781 26.7121 11.9904 25.123 11.1026 23.5336C10.9543 23.2714 10.9745 22.9464 11.1542 22.7046C11.5826 22.0365 12.012 21.3688 12.4423 20.7014C12.5118 20.5908 12.5842 20.4779 12.6612 20.3575V20.3575Z'
                stroke='#2A2A2A'
              />
              <path
                fill-rule='evenodd' clip-rule='evenodd'
                d='M21.8923 26.9789C21.8767 28.5936 21.8616 30.2002 21.846 31.8213H21.7157C20.2527 31.8074 18.7891 31.7877 17.3261 31.7825C16.9315 31.7977 16.5392 31.7148 16.1845 31.5411C15.6907 31.2674 15.322 30.8132 15.1557 30.2737C14.964 29.6903 15.0021 29.0556 15.2622 28.4993C15.3642 28.2613 15.484 28.0314 15.6206 27.8115C15.7804 27.544 15.9575 27.2875 16.1324 27.0293C16.1596 26.9915 16.2018 26.967 16.2481 26.9622C18.1085 26.9622 19.9687 26.966 21.8286 26.9737C21.8437 26.9749 21.8593 26.9789 21.8923 26.9789V26.9789Z'
                stroke='#2A2A2A'
              />
              <path
                fill-rule='evenodd' clip-rule='evenodd'
                d='M29.0658 14.3544C29.4178 14.1668 29.7606 13.9822 30.1351 13.7847C30.1091 13.8386 30.0981 13.8669 30.0836 13.8936C29.397 15.1333 28.7104 16.3734 28.0237 17.6139C28.0014 17.6721 27.9418 17.7071 27.8801 17.6984C26.5123 17.6162 25.1436 17.5357 23.7742 17.457C23.7465 17.457 23.7163 17.4506 23.6637 17.4443L24.7637 16.8572C24.744 16.8184 24.7283 16.7866 24.711 16.7553C24.0761 15.5615 23.4406 14.3685 22.8045 13.1763C22.6349 12.8584 22.4635 12.5394 22.2806 12.2303C22.1985 12.1004 22.1055 11.9778 22.0027 11.8638C21.9341 11.784 21.8579 11.7111 21.7751 11.6461C21.6904 11.5849 21.6025 11.5283 21.5117 11.4765C21.536 11.4765 21.558 11.4684 21.58 11.4678C23.4006 11.4604 25.2212 11.4539 27.0418 11.4481C27.3431 11.4452 27.6176 11.6205 27.7418 11.895C28.1185 12.5933 28.4944 13.2924 28.8696 13.9926L29.0658 14.3544Z'
                stroke='#2A2A2A'
              />
              <path
                fill-rule='evenodd' clip-rule='evenodd'
                d='M18.7945 19.221L14.582 16.8329C14.6052 16.7906 14.6249 16.7547 14.6451 16.7171C15.3665 15.4434 16.0925 14.1738 16.8069 12.896C16.9851 12.5436 17.2478 12.2408 17.5717 12.0149C18.0504 11.7156 18.6264 11.6133 19.1789 11.7295C19.7823 11.8444 20.3191 12.1855 20.6795 12.683C20.8383 12.8874 20.9813 13.1036 21.1073 13.3297C21.2637 13.5989 21.402 13.8785 21.5433 14.1564C21.5629 14.1982 21.5641 14.2462 21.5468 14.289C20.6436 15.9151 19.7383 17.54 18.8309 19.1637C18.8222 19.1782 18.8147 19.1909 18.7945 19.221V19.221Z'
                stroke='#2A2A2A'
              />
              <path
                fill-rule='evenodd' clip-rule='evenodd'
                d='M25.8892 31.8873V33.099C25.8539 33.0509 25.8342 33.0278 25.8174 33.0023C25.0455 31.8132 24.2736 30.6246 23.5016 29.4366C23.4608 29.3897 23.4577 29.3208 23.4941 29.2704C24.2089 28.1002 24.9229 26.9294 25.6362 25.7579C25.6507 25.7342 25.6675 25.7122 25.6993 25.6665V26.9153H25.8151C27.166 26.9153 28.5169 26.9141 29.8677 26.9118C30.2284 26.9118 30.5891 26.9089 30.9492 26.8933C31.1028 26.8816 31.255 26.8566 31.4043 26.8186C31.5067 26.7951 31.6068 26.762 31.703 26.7196C31.795 26.6791 31.8801 26.6217 31.9768 26.5667C31.9676 26.5899 31.9618 26.6119 31.9519 26.6316C31.1028 28.2422 30.2537 29.8526 29.4046 31.4629C29.2653 31.7302 28.9817 31.8904 28.6809 31.8716C27.887 31.8755 27.093 31.879 26.2991 31.8821C26.1694 31.8855 26.0322 31.8861 25.8892 31.8873V31.8873Z'
                stroke='#2A2A2A'
              />
              <path
                fill-rule='evenodd' clip-rule='evenodd'
                d='M26.4141 20.5376L30.5009 17.9393C30.5269 17.9792 30.5495 18.0134 30.5715 18.0481C31.3565 19.283 32.1346 20.5214 32.9295 21.7534C33.1574 22.076 33.3016 22.4502 33.3493 22.8424C33.3884 23.4054 33.2083 23.9617 32.8467 24.3951C32.4618 24.8737 31.9087 25.1874 31.3004 25.2722C31.0452 25.3166 30.787 25.3414 30.5281 25.3463C30.2172 25.3579 29.9057 25.3463 29.5936 25.3434C29.5478 25.3412 29.5049 25.3203 29.475 25.2855C28.463 23.7247 27.4531 22.1625 26.4453 20.5989C26.4366 20.581 26.4303 20.5665 26.4141 20.5376V20.5376Z'
                stroke='#2A2A2A'
              />
            </svg>
          </div>
          <div class='Capsule-details'>
            <div class='Capsule-category'>{t('js.proof_point.partly_recyclable_packaging')}</div>
            <div>
              <proof-point-status verified style='transform: none'>
                <svg xmlns='http://www.w3.org/2000/svg' width='15' height='14' fill='none'>
                  <circle cx='7.5' cy='7' r='7' fill='#99B9AE' />
                  <path
                    fill-rule='evenodd' clip-rule='evenodd'
                    d='M10.803 4.23a.583.583 0 0 1 .051.823L6.976 9.45a.875.875 0 0 1-1.361-.06L4.113 7.345a.583.583 0 1 1 .94-.69l1.104 1.5a.25.25 0 0 0 .389.017l3.433-3.892a.583.583 0 0 1 .824-.051Z'
                    fill='#fff'
                  />
                </svg>
                &nbsp;{t('js.verified_label')}
              </proof-point-status>
            </div>
          </div>
        </div>
      </div>
      <div class='Tag theme-waste'>{t('js.theme.waste')}</div>
    </li>
    <li class='CapsuleList-item'>
      <div class='CapsuleList-item--button'>
        <div class='Capsule'>
          <div class='Capsule-icon Capsule-icon--claim'>
            <svg
              xmlns='http://www.w3.org/2000/svg' width='44' height='44' viewBox='0 0 44 44' class='Capsule-iconInner'
              preserveAspectRatio='xMaxYMax meet'
            >
              <g fill='none' fill-rule='evenodd' stroke='#2A2A2A'>
                <path
                  d='M26.4 17.103C22.945 16.713 20 23.5 20 23.5s1.467-6.266 4.655-8.33c3.188-2.063 4.621.044 6.125-2.552a3.805 3.805 0 0 1-.48 3.769c-1.57 2.296-4.429 4.425-7.532 3.628'
                />
                <path
                  d='M20.089 23.247a36.074 36.074 0 0 0-1.699 8.192S17.386 21.742 7.41 13.412c0 0 7.983.923 10.224 8.601M29.337 32.24c1.97 0 3.81-.648 5.08-1.84l-1.244-1.788c-.907.907-2.333 1.4-3.577 1.4-2.358 0-3.758-1.582-3.965-3.448h9.641v-.674c0-3.94-2.384-6.79-6.142-6.79-3.706 0-6.35 2.929-6.35 6.557 0 3.965 2.773 6.583 6.557 6.583zm3.317-7.62h-7.049c.104-1.503 1.192-3.291 3.499-3.291 2.462 0 3.473 1.814 3.55 3.291z'
                />
              </g>
            </svg>
          </div>
          <div class='Capsule-details'>
            <div class='Capsule-category'>{t('js.proof_point.vegan')}</div>
            <div>
              <proof-point-status verified style='transform: none'>
                <svg xmlns='http://www.w3.org/2000/svg' width='15' height='14' fill='none'>
                  <circle cx='7.5' cy='7' r='7' fill='#99B9AE' />
                  <path
                    fill-rule='evenodd' clip-rule='evenodd'
                    d='M10.803 4.23a.583.583 0 0 1 .051.823L6.976 9.45a.875.875 0 0 1-1.361-.06L4.113 7.345a.583.583 0 1 1 .94-.69l1.104 1.5a.25.25 0 0 0 .389.017l3.433-3.892a.583.583 0 0 1 .824-.051Z'
                    fill='#fff'
                  />
                </svg>
                &nbsp;{t('js.verified_label')}
              </proof-point-status>
            </div>
          </div>
        </div>
      </div>
      <div class='Tag theme-nature'>{t('js.theme.nature')}</div>
    </li>
  </ul>

export default StaticCapsuleList
